import React from "react";
import { withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import { withTranslation } from "react-i18next";
import MuiAlert from "@material-ui/lab/Alert";
import Typography from "../Helpers/Typography";

const styles = (theme) => ({
  root: {
    background: theme.palette.primary.dark,
    color: "#FFFFFF",
    fontSize: "14px",
    marginLeft: "48px",
    radius: "1px",
    shadow: "outer x, y -0px, 3px",
  },
  message: {
    listStyle: "none",
  },
});

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SPSnackbar = (props) => {
  const { handleClose, message, t, classes, alertSeverity } = props;

  const renderedMessage =
    typeof message === "string" ? (
      <Typography id="message-id">{message}</Typography>
    ) : (
      <ul className={classes.message}>
        {message.map((item) => (
          <li key={item}>{t(item)}</li>
        ))}
      </ul>
    );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={props.open}
      autoHideDuration={6000}
      onClose={handleClose}
      ContentProps={{
        "aria-describedby": "message-id",
        classes,
      }}
    >
      <Alert onClose={handleClose} severity={alertSeverity} sx={{ width: "100%" }}>
        {renderedMessage}
      </Alert>
    </Snackbar>
  );
};

SPSnackbar.propTypes = {
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  open: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  alertSeverity: PropTypes.string,
};

SPSnackbar.defaultProps = {
  alertSeverity: "info",
};

export default withTranslation("common")(withStyles(styles)(SPSnackbar));
